import GroupIcon from "@mui/icons-material/Group";
import { Box, Checkbox, FormControlLabel, Grid, MenuItem, Radio, Select, TextField } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { removeConfirmationWord } from "ui/Scripts/source/models/consts";
import { ConfirmationDialogResult, EnumHelper, InstantMessageChannelArchivingType, InstantMessageChannelMessageExpirationTime, InstantMessageChannelUserType } from "ui/Scripts/source/models/enums";
import { IInstantMessageChannelAddedUser } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddedUser";
import { IInstantMessageChannelEditItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelEditItem";
import { InstantMessageChannelHelper } from "ui/Scripts/source/models/instantMessage/instantMessageChannelHelper";
import { IInstantMessageChannelEditUserItem, InstantMessageChannelEditUserItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelUserEditItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { SaveAttachmentBase64 } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";
import { AppUtils } from "../../../framework/appUtils";
import * as store from "../../../framework/customStore";
import { SaveDataObj } from "../../../framework/saveData";
import * as instantMessageChannelService from "../../../models/services/instantMessageChannelService";
import { ISessionState } from "../../../models/session/sessionState";
import * as storeActions from "../../../models/store/storeActions";
import { IUserListItem } from "../../../models/user/userListItem";
import { Dialog } from "../../framework/Dialog/Dialog";
import { DialogButtons } from "../../framework/Dialog/DialogButtons";
import { DialogTabs } from "../../framework/Dialog/DialogTabs";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { InstantMessageChannelEditDialogUserList } from "../InstantMessageChannelEditDialogUserList";
import { DialogItemsNav } from "source/components/framework/Dialog/DialogItemsNav";

/* eslint-disable no-unused-vars */
export const enum InstantMessageChannelDialogMenuItem {
    General = "1",
    Users = "2"
}
/* eslint-enable no-unused-vars */

export interface IInstantMessageChannelSaveState {
    companyId: string;
    id: string;
    code: string;
    file: IFileAttachment,
    resetPicture: boolean;
    internalChannel: boolean;
    oneToOneChannel: boolean; //Used only for new channel to determine if the channel is one to one or group, as this cannot be changed after creation
    activeState: number;
    archivingType: number;
    archivingRemoveDate: string;
    comment: string;
    messageExpirationTime: number;
    rowId: string;
}

export interface IInstantMessageChannelEditDialogProp {
    sessionState: ISessionState;
    defaultMenuItem: InstantMessageChannelDialogMenuItem;
    companyId: string;
    instantMessageChannelId: string;
    classes?: string;
    onOk: () => void;
    onCancel: (instantMessageChannelDataWasModified: boolean) => void;
    onNewSaved: (instantMessageChannelId: string) => void;
    refreshChannelList: (companyId: string, instantMessageChannelId: string) => void;
}

export interface IInstantMessageChannelEditDialogState extends IInstantMessageChannelSaveState {
    activeMenuItem: InstantMessageChannelDialogMenuItem;
    isLoading: boolean;
    instantMessageChannelDataWasModified: boolean;
    instantMessageChannel: IInstantMessageChannelEditItem;
    picture: string;
    companies: ICompanyMenuItem[];
    users: IInstantMessageChannelEditUserItem[];
    userIsInstantMessageChannelAdmin: boolean;
    messageExpirationTimes: INumberTitle[];
    defaultArchivingRemoveDate: string;
}

export class InstantMessageChannelEditDialog extends React.Component<IInstantMessageChannelEditDialogProp, IInstantMessageChannelEditDialogState> {
    private orgStateHash: string = "";

    constructor(props: IInstantMessageChannelEditDialogProp) {
        super(props);
        this.state = {
            activeMenuItem: Base.isNullOrUndefined(props.defaultMenuItem) ? InstantMessageChannelDialogMenuItem.General : props.defaultMenuItem,
            isLoading: false,
            instantMessageChannelDataWasModified: false,
            instantMessageChannel: null,
            companyId: "",
            id: "",
            code: "",
            file: null,
            picture: "",
            resetPicture: false,
            internalChannel: false,
            oneToOneChannel: false,
            activeState: 0,
            archivingType: 0,
            archivingRemoveDate: "",
            comment: "",
            messageExpirationTime: 0,
            rowId: "",
            companies: [],
            users: [],
            userIsInstantMessageChannelAdmin: false,
            defaultArchivingRemoveDate: "",
            messageExpirationTimes: [
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Quarter, "3 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.HalfYear, "6 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Year, "12 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.None, Translations.Unlimited)
            ]
        };
    }

    loadInstantMessageChannel = async () => {
        const props = this.props;
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => instantMessageChannelService.getInstantMessageChannelEdit(props.companyId, props.instantMessageChannelId), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const instantMessageChannel = result.instantMessageChannel;
        const state = {
            ...this.state,
            instantMessageChannel,
            companyId: instantMessageChannel.companyId,
            id: instantMessageChannel.id,
            code: instantMessageChannel.code,
            file: null,
            resetPicture: false,
            picture: instantMessageChannel.picture,
            internalChannel: instantMessageChannel.internalChannel,
            activeState: instantMessageChannel.activeState,
            archivingType: instantMessageChannel.archivingType,
            archivingRemoveDate: Base.timeToDateStr(instantMessageChannel.archivingRemoveDate ? instantMessageChannel.archivingRemoveDate : result.archivingRemoveDate),
            defaultArchivingRemoveDate: Base.timeToDateStr(result.archivingRemoveDate),
            comment: instantMessageChannel.comment,
            messageExpirationTime: instantMessageChannel.messageExpirationTime,
            rowId: instantMessageChannel.rowId,
            companies: result.companies,
            users: result.users,
            userIsInstantMessageChannelAdmin: result.userIsInstantMessageChannelAdmin
        };
        this.setState(state);
        const saveData = await InstantMessageChannelEditDialog.getSaveDataFromState(state);
        this.orgStateHash = saveData.hash;
    };

    componentDidMount(): void {
        this.loadInstantMessageChannel();
    }

    async componentDidUpdate(prevProps: IInstantMessageChannelEditDialogProp, prevState: IInstantMessageChannelEditDialogState): Promise<void> {
        const props = this.props;
        const state = this.state;
        const prevDefaultMenuItem = Base.isNullOrUndefined(prevProps.defaultMenuItem) ? InstantMessageChannelDialogMenuItem.General : prevProps.defaultMenuItem;
        const defaultMenuItem = Base.isNullOrUndefined(props.defaultMenuItem) ? InstantMessageChannelDialogMenuItem.General : props.defaultMenuItem;
        if (prevProps.companyId === props.companyId && prevProps.instantMessageChannelId === props.instantMessageChannelId) return;
        const cancelResult = await AppUtils.cancel((await InstantMessageChannelEditDialog.getSaveDataFromState(state)).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            if (!await this.saveToDb()) return;
            props.refreshChannelList(props.companyId, props.instantMessageChannelId);
        }
        await this.loadInstantMessageChannel();
        if (prevDefaultMenuItem !== defaultMenuItem) {
            this.setState({
                activeMenuItem: defaultMenuItem
            });
        }
    }

    handleToggleActiveMenuItem = (instantMessageChannelDialogMenuItem: InstantMessageChannelDialogMenuItem) => {
        this.setState({
            activeMenuItem: instantMessageChannelDialogMenuItem
        });
    };

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "xts") {
            this.setState({ code: value });
        } else if (name === "comment") {
            this.setState({ comment: value });
        } else if (name === "messageExpirationTime") {
            this.setState({ messageExpirationTime: value.toInteger() });
        }
    };

    handleSetPicture = async (file: File) => {
        if (!file) return;
        const attachment = await FileAttachment.fileToFileAttachment(file, 0);
        if (!attachment) return;
        if (!AppUtils.validateFileAttachment(attachment)) return;
        this.setState({ file: attachment, resetPicture: false, picture: attachment.thumbnail });
    };

    handleRemovePicture = () => {
        this.setState({ file: null, resetPicture: true, picture: "" });
    };

    handleSetArchivingType = (archivingType: number) => {
        const state = this.state;
        const archivingRemoveDate = !EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, state.archivingType) &&
            EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, archivingType)
            ? state.defaultArchivingRemoveDate
            : state.archivingRemoveDate;
        this.setState({
            archivingType,
            archivingRemoveDate
        });
    };

    // #region Users
    handleUsersRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            users: this.state.users.filter(i => ids.indexOf(i.id) < 0),
            instantMessageChannelDataWasModified: true
        });
    };
    
    handleUsersAdded = (companyId :string, newUsers: IUserListItem[], addedUsers: IInstantMessageChannelAddedUser[]) => {
        if (!newUsers || newUsers.length < 1) return;
        const state = this.state;
        const users = state.users.slice(0);
        for (const newUser of newUsers) {
            const addedUser = addedUsers.find(i => i.userId === newUser.id);
            if (!addedUser) continue;
            const user = new InstantMessageChannelEditUserItem();
            user.id = addedUser.id;
            user.companyId = companyId;
            user.userType = InstantMessageChannelUserType.User;
            user.userCode = newUser.code;
            user.firstName = newUser.firstName;
            user.lastName = newUser.lastName;
            user.picture = newUser.picture;
            user.activeState = addedUser.activeState;
            users.push(user);
        }
        this.setState({
            users,
            instantMessageChannelDataWasModified: true
        });
    };

    handleUserTypeUpdated = async (id: string, userType: number) => {
        const state = this.state;
        const user = state.users.find(i => i.id === id);
        if (!user) return;
        const newUser = new InstantMessageChannelEditUserItem(user);
        const users = state.users.filter(i => i.id !== id);
        newUser.userType = userType;
        users.push(newUser);
        this.setState({
            users,
            instantMessageChannelDataWasModified: true
        });
    };
    // #endregion Users

    static getSaveDataFromState = async (state: IInstantMessageChannelSaveState, overrideCode: string = null, userIds: string[] = null): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("companyId", state.companyId);
        result.append("id", state.id);
        result.append("rowId", state.rowId);
        result.append("code", overrideCode ?? state.code);
        result.append("comment", state.comment);
        result.append("internalChannel", state.internalChannel);
        result.append("oneToOneChannel", state.oneToOneChannel);
        result.append("activeState", state.activeState);
        result.append("archivingType", state.archivingType);
        result.append("archivingRemoveDate", EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, state.archivingType) ? state.archivingRemoveDate.toDate().getTime() : null);
        result.append("messageExpirationTime", state.messageExpirationTime);
        result.append("resetPicture", state.resetPicture);
        if (state.file) {
            result.append("attachments", await SaveAttachmentBase64.fromFileAttachments([state.file]));
        }
        if (userIds) { //Used only for saving in new wizard
            result.append("userIds", userIds);
        }
        return result;
    };
    
    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            const isNew = state.instantMessageChannel.isNew();
            if (!isNew && !state.code) {
                store.customStore.dispatch(storeActions.showErrorMessage(Translations.NameMustBeDefined));
                return resolve(false);
            }
            return resolve(true);
        });
    };

    static saveInstantMessageChannel = async (state: IInstantMessageChannelSaveState, overrideCode: string, userIds: string[] = null): Promise<SaveSuccess> => {
        const saveData = await InstantMessageChannelEditDialog.getSaveDataFromState(state, overrideCode, userIds);
        return AppUtils.callService(() => instantMessageChannelService.saveInstantMessageChannelEdit(saveData.obj));
    };

    saveToDb = async (): Promise<SaveSuccess> => {
        const state = this.state;
        const isNew = state.instantMessageChannel.isNew();
        const overrideCode = isNew && !state.code ? Translations.NewInstantMessageChannel : null;
        if (!await AppUtils.validate(this.checkErrors)) return null;
        //Call server
        const result = await InstantMessageChannelEditDialog.saveInstantMessageChannel(state, overrideCode);
        if (!result) return null;
        this.orgStateHash = (await InstantMessageChannelEditDialog.getSaveDataFromState(state, overrideCode)).hash;
        if (overrideCode) {
            this.setState({ code: overrideCode });
        }
        return result;
    };

    handleSave = async () => {
        const props = this.props;
        const result = await this.saveToDb();
        if (!result) return;
        const isNew = this.state.instantMessageChannel.isNew();
        if (!isNew) {
            props.onOk();
        } else {
            props.onNewSaved(result.id);
        }
    };

    handleRemove = async () => {
        const props = this.props;
        const state = this.state;
        if (state.instantMessageChannel.isNew()) return;
        const fixedName = InstantMessageChannelHelper.getFixedName(state.users, props.sessionState.code);
        if (await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveInstantMessageChannelParameter, fixedName ?? state.instantMessageChannel.code), false, removeConfirmationWord) === ConfirmationDialogResult.Yes) {
            // Call server
            const result = await AppUtils.callService(() => instantMessageChannelService.removeInstantMessageChannel(state.instantMessageChannel.id, props.companyId));
            if (!result) return;
            props.onCancel(true);
        }
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel((await InstantMessageChannelEditDialog.getSaveDataFromState(state)).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.handleSave();
        } else {
            props.onCancel(state.instantMessageChannelDataWasModified);
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.instantMessageChannel) return null;
        const hasPartners = state.companies.length > 1;
        const hasExternalUsers = !!state.users.find(i => i.companyId !== state.companyId);
        const isNew = state.instantMessageChannel.isNew();
        const fixedName = InstantMessageChannelHelper.getFixedName(state.users, props.sessionState.code);
        const isReadOnly = !state.userIsInstantMessageChannelAdmin;
        const avatarImageClass = InstantMessageChannelHelper.getPictureClass(state.users, state.picture, props.sessionState.code);
        return (
            <Dialog
                id="instant-message-channel-edit-dialog"
                maxWidth="md"
                maxHeight="774px"
                title={isNew ? Translations.AddInstantMessageChannel : ((isReadOnly ? Translations.InstantMessageChannel : Translations.EditInstantMessageChannel) + ": " + (fixedName ?? state.code))}
                dialogTabs={
                    <DialogTabs
                        activeTabId={state.activeMenuItem}
                        tabs={[
                            { id: InstantMessageChannelDialogMenuItem.General, title: Translations.BasicInformation },
                            { id: InstantMessageChannelDialogMenuItem.Users, title: Translations.InstantMessageChannelUsers, hidden: isNew },
                        ]}
                        onChangeTab={this.handleToggleActiveMenuItem}
                    />
                }
                body={
                    <>
                        {state.activeMenuItem === InstantMessageChannelDialogMenuItem.General &&
                            <>
                                <GridRow>
                                    <Grid item sm={12}>
                                        <Box display="flex" alignItems="flex-end">
                                            <AvatarImage
                                                id={InstantMessageChannelHelper.getAvatarId(state.users, state.picture, props.sessionState.code)}
                                                name={fixedName ?? state.code}
                                                image={InstantMessageChannelHelper.getPicture(state.users, state.picture, props.sessionState.code)}
                                                icon={avatarImageClass.includes("instantMessageGroup") ? <GroupIcon color="info" fontSize="large" /> : undefined}
                                                size={60}
                                                marginRight="1.5rem"
                                                editable={!isReadOnly}
                                                tooltip={Translations.CkickToChangeThePicture}
                                                removeTooltip={Translations.RemovePicture}
                                                onChange={this.handleSetPicture}
                                                onClear={state.resetPicture ? null : this.handleRemovePicture}
                                                onError={(message) => { store.customStore.dispatch(storeActions.showErrorMessage(message)); }}
                                            />
                                            <FormField title={Translations.Name} required={isNew} margin={0}>
                                                <TextField type="text" name="xts" title={Translations.Name} inputProps={{ maxLength: 50 }} value={fixedName ?? state.code} disabled={!!fixedName || isReadOnly} onChange={this.handleChange} />
                                            </FormField>
                                        </Box>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.MessagePreservationTime} required>
                                            <Select name="messageExpirationTime" title={Translations.MessagePreservationTime} value={state.messageExpirationTime.toString(10)} disabled={isReadOnly} onChange={this.handleChange}>
                                                {state.messageExpirationTimes.map((messageExpirationTime) =>
                                                    <MenuItem key={messageExpirationTime.number} value={messageExpirationTime.number.toString(10)}>{messageExpirationTime.title}</MenuItem>
                                                )}
                                            </Select>
                                        </FormField>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.Description}>
                                            <TextField name="comment" title={Translations.Description} inputProps={{ maxLength: 500 }} multiline minRows={5} disabled={isReadOnly} value={state.comment} required={true} onChange={this.handleChange} />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                                {!isNew &&
                                    <GridRow>
                                        {hasPartners &&
                                            <Grid item sm={6}>
                                                <FormField title={null}>
                                                    <FormControlLabel
                                                        label={Translations.InstantMessageChannelInternal}
                                                        control={
                                                            <Checkbox
                                                                checked={state.internalChannel}
                                                                disabled={isReadOnly || !state.internalChannel && hasExternalUsers}
                                                                onChange={(_e, checked: boolean) => {
                                                                    this.setState({ internalChannel: checked });
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </FormField>
                                            </Grid>
                                        }
                                        <Grid item sm={6}>
                                            <FormField title={null}>
                                                <FormControlLabel
                                                    label={Translations.Archived}
                                                    control={
                                                        <Checkbox
                                                            checked={state.activeState < 0.5}
                                                            disabled={isReadOnly}
                                                            onChange={(_e, checked: boolean) => {
                                                                this.setState({
                                                                    activeState: checked ? 0 : 1,
                                                                    archivingType: checked ? InstantMessageChannelArchivingType.KeepMessages : InstantMessageChannelArchivingType.None
                                                                });
                                                            }}
                                                        />
                                                    }
                                                />
                                            </FormField>
                                        </Grid>
                                    </GridRow>
                                }
                                {state.activeState < 0.5 &&
                                    <GridRow>
                                        <Grid item xs>
                                            <FormField title={Translations.InstantMessageChannelArchivingType}>
                                                <GridRow>
                                                    <Grid item sm={6}>
                                                        <FormControlLabel
                                                            label={Translations.InstantMessageChannelArchivingTypeKeepMessages}
                                                            control={
                                                                <Radio
                                                                    checked={EnumHelper.isEqual(InstantMessageChannelArchivingType.KeepMessages, state.archivingType)}
                                                                    disabled={isReadOnly}
                                                                    onChange={(_e, checked: boolean) => {
                                                                        this.handleSetArchivingType(checked ? InstantMessageChannelArchivingType.KeepMessages : InstantMessageChannelArchivingType.RemoveChannel);
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid item sm={6}>
                                                        <FormControlLabel
                                                            label={String.format(Translations.InstantMessageChannelArchivingTypeRemoveChannelAtDateParameter, state.archivingRemoveDate)}
                                                            control={
                                                                <Radio
                                                                    checked={EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, state.archivingType)}
                                                                    disabled={isReadOnly}
                                                                    onChange={(_e, checked: boolean) => {
                                                                        this.handleSetArchivingType(checked ? InstantMessageChannelArchivingType.RemoveChannel : InstantMessageChannelArchivingType.KeepMessages);
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    </Grid>
                                                </GridRow>
                                            </FormField>
                                        </Grid>
                                    </GridRow>
                                }
                            </>
                        }
                        {state.activeMenuItem === InstantMessageChannelDialogMenuItem.Users &&
                            <InstantMessageChannelEditDialogUserList
                                sessionState={props.sessionState}
                                companies={hasPartners && !state.internalChannel ? state.companies : [state.companies[0]]}
                                isReadOnly={isNew || isReadOnly}
                                instantMessageChannelId={state.id}
                                instantMessageChannelCompanyId={state.companyId}
                                users={state.users}
                                onRemoved={this.handleUsersRemoved}
                                onAdded={this.handleUsersAdded}
                                onUserTypeUpdated={this.handleUserTypeUpdated}
                            />
                        }
                    </>
                }
                actions={
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <DialogItemsNav
                            hasPrevious={false}
                            hasNext={false}
                            onPrevious={null}
                            onNext={null}
                            modifyUser={!isNew ? state.instantMessageChannel.modifyUser : null}
                        />
                        <DialogButtons
                            isNew={isNew}
                            onCancel={this.handleCancel}
                            onRemove={state.instantMessageChannel && !isNew && !isReadOnly ? this.handleRemove : null}
                            onSave={!isReadOnly ? this.handleSave : null}
                        />
                    </Box>
                }
                onClose={this.handleCancel}/>
        );
    }
}